export function getPasswordMismatchError(password, passwordAgain, translate, requireBoth = false) {
    if (requireBoth && (password === '' || passwordAgain === '')) {
        return null;
    }

    return password !== passwordAgain ? translate('auth.passwords-must-match') : null;
}
